module.exports = __webpack_public_path__ + "static/media/only_cuffs_threads.2dfb0d90.svg";